import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import UtilityPanel from "./UtilityPanel";

interface LayoutProps {
  children: React.ReactNode;
  userType: "jobseeker" | "hr" | "admin";
}

const Layout: React.FC<LayoutProps> = ({ children, userType }) => {
  // Default context panel to collapsed (false), user can expand when needed
  const [isUtilityPanelOpen, setIsUtilityPanelOpen] = useState(false);

  const handleToggleUtilityPanel = () => {
    setIsUtilityPanelOpen((previous) => !previous);
  };

  return (
    <div className="flex min-h-screen w-full overflow-x-hidden relative">
      {/* Animated Background Gradient */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50"></div>
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-br from-blue-400/20 to-purple-600/20 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-purple-400/20 to-pink-600/20 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
      </div>

      <Sidebar userType={userType} />
      <div className="flex flex-1 flex-col min-w-0 overflow-x-hidden">
        <Header
          userType={userType}
          onUtilityToggle={handleToggleUtilityPanel}
          isUtilityPanelOpen={isUtilityPanelOpen}
        />
        <div className="flex flex-1 overflow-visible">
          <main className="flex-1 overflow-y-auto overflow-x-visible px-8 py-8">
            <div className="mx-auto max-w-[1400px] space-y-8 overflow-visible">
              {children}
            </div>
          </main>
          <UtilityPanel
            isOpen={isUtilityPanelOpen}
            userType={userType}
            onClose={handleToggleUtilityPanel}
          />
        </div>
      </div>
    </div>
  );
};

export default Layout;
